import { Button, Icon } from '@flatfile/baseline'
import { useState } from 'react'
import { CreateSheetModal } from './CreateSheetModal'

interface EmptySheetStateProps {
  projectId: string
  onSheetCreated?: () => void
}

export function EmptySheetState({
  projectId,
  onSheetCreated,
}: EmptySheetStateProps) {
  const [showCreateModal, setShowCreateModal] = useState(false)

  return (
    <>
      <div className='flex items-center justify-center h-full bg-gray-50'>
        <div className='text-center max-w-md p-8'>
          <div className='mb-6'>
            <Icon name='GridView' size={32} className='text-gray-400 mx-auto' />
          </div>

          <h2 className='text-2xl font-semibold text-gray-900 mb-2'>
            No data yet
          </h2>

          <p className='text-gray-600 mb-6'>
            Get started by creating a sheet or uploading a file to begin
            preparing your data.
          </p>

          <div className='space-y-3'>
            <Button
              variant='primary'
              size='lg'
              icon='Plus'
              onClick={() => setShowCreateModal(true)}
              className='w-full'
            >
              Create New Sheet
            </Button>

            <Button
              variant='outline'
              size='lg'
              icon='upload'
              onClick={() =>
                (window.location.href = `/projects/${projectId}/upload`)
              }
              className='w-full'
            >
              Upload File
            </Button>
          </div>

          <div className='mt-8 p-4 bg-blue-50 rounded-lg border border-blue-200'>
            <div className='flex items-start space-x-2'>
              <Icon
                name='information-circle'
                size={20}
                className='text-blue-600 mt-0.5'
              />
              <div className='text-sm text-blue-900'>
                <p className='font-medium mb-1'>Pro tip:</p>
                <p>
                  You can also use the chat to describe your data structure. For
                  example:
                </p>
                <p className='italic mt-1'>
                  "Create a customer sheet with fields for name, email, phone,
                  and address"
                </p>
              </div>
            </div>
          </div>
        </div>
      </div>

      <CreateSheetModal
        isOpen={showCreateModal}
        onClose={() => setShowCreateModal(false)}
        projectId={projectId}
        onSheetCreated={onSheetCreated}
      />
    </>
  )
}
